import {
  formatDate,
  formatTime,
  getByFieldValue,
  isBlank,
  isEmptyList,
  isNullOrUndefined,
} from "../../utils";
import { ReactComponent as Pencil } from "../../assets/pencil.svg";
import { ReactComponent as Ban } from "../../assets/ban.svg";
import { ReactComponent as Clock } from "../../assets/clock.svg";
import { ReactComponent as Send } from "../../assets/send.svg";
import { useTranslation } from "react-i18next";
import { getUserInfo } from "../../userUtils";
import ImageAsset from "../ImageAsset";
import { useMainContext } from "../../MainContext";

function TurnarounDocsItem(props) {
  const { t } = useTranslation();
  const { item, timezone, onEdit, onShowImage, isReadonly } = props;
  const mainContext = useMainContext();
  const { users } = mainContext;
  const user =
    !isNullOrUndefined(item?.submittedByUserUuid) && !isEmptyList(users)
      ? getByFieldValue(users, "uuid", item?.submittedByUserUuid)
      : null;
  const userInfo = !isNullOrUndefined(user) ? getUserInfo(user) : null;

  function handleEdit() {
    onEdit();
  }

  return (
    <div className="turnaround-module-docs-item" key={item.uuid}>
      <div>
        <div className="turnaround-module-docs-item-detail">
          <div>
            <div
              className={`turnaround-module-docs-item-image${
                item.skipped ? " skipped" : ""
              }`}
            >
              {item.skipped && <Ban />}
              {!item.skipped && (
                <ImageAsset
                  imageUrl={
                    isReadonly ? item?.image?.thumbnail : item?.image?.fullSize
                  }
                  onClick={!isBlank(item?.image?.fullSize) ? onShowImage : null}
                />
              )}
            </div>
          </div>
          <div className="turnaround-module-docs-item-name">
            <div className="turnaround-module-docs-item-name-parts">
              <div>{item.name}</div>
              <div>{item.skipped && <>({t("skipped")})</>}</div>
            </div>
            <div className="turnaround-module-docs-item-notes">
              {item.notes}
            </div>
          </div>
        </div>
        <div>
          {!isNullOrUndefined(item.timestamp) && (
            <div className="datetime-range-values">
              <div>
                <Clock />
              </div>
              <div>
                <div>{formatTime(item.timestamp, timezone)}</div>
                <div className="datetime-range-values-detail">
                  {formatDate(item.timestamp, timezone)}
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          {!isNullOrUndefined(userInfo) && (
            <div className="turnaround-module-docs-item-submitter">
              <div>
                <Send />
              </div>
              <div>
                <div>{userInfo.fullName}</div>
                <div className="turnaround-module-docs-item-submitter-details">
                  {!isNullOrUndefined(item.submittedAt) && (
                    <>
                      {`${formatTime(item.submittedAt, timezone)} ${formatDate(
                        item.submittedAt,
                        timezone
                      )}`}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
        <div>
          {!isReadonly && (
            <div className="button-icon small circle" onClick={handleEdit}>
              <Pencil />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TurnarounDocsItem;
